import styled from 'styled-components';

const MainStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 650px;

  .tax-notification {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .aiBanner {
    border-radius: 16px;
    background: #13194b;
    display: flex;
    padding: 24px;
    align-items: flex-end;
    gap: 16px;
    align-self: stretch;
  }

  .aiBannerImg {
    border-radius: 15px;
    background: #2a305d;
    padding: 10px;
  }

  .noticeBox {
    border-radius: 16px;
    background: var(--Primary-50, #f4f3ff);
    padding: 16px;
  }

  .aiAssistantBanner {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    border-radius: 16px;
    background: var(--GrayScale-100, #f5f5f5);
    height: 112px;
    align-items: center;
    flex: 2;
    align-self: stretch;

    .aiGrayBox {
      display: flex;
      gap: 5px;
      padding: 10px;
      justify-content: center;
      align-items: center;
      border-radius: 15px;
      background: rgba(84, 77, 92, 0.15);
    }
  }
`;

export default MainStyled;

export const TaxResultBox = styled.div`
  border-radius: 16px;
  border: 1px solid var(--GrayScale-400, #ddd);
  display: flex;
  padding: 8px 24px;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;
